/**
 * Route for `regional-data-residency-india-eu-us`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RegionalDataResidencyIndiaEuUsPage } from "../features/regional-data-residency-india-eu-us/RegionalDataResidencyIndiaEuUsPage";

export const regionalDataResidencyIndiaEuUsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/regional-data-residency-india-eu-us",
	component: RegionalDataResidencyIndiaEuUsPage,
});

export default regionalDataResidencyIndiaEuUsRoute;
